<template>
  <div style="max-width: 500px; position: relative; height:100%;" class="Kanit mx-auto bg-subpage">
    <!-- Header -->
    <Header :isHeaderFixed="false"></Header>

    <!-- Content Box -->
    <div class="wrapper-content-box">
      <div class="content-box">
        <p style="font-size: 24px; font-weight: 700; letter-spacing: 1px; margin-bottom: 60px;">
          วิธีการสมัคร<br><span style="color:#B6907D; text-transform: uppercase;">Lamy Club</span>
        </p>
        <div style="margin-bottom: 60px;">
          <div class="text-center mt-2">
            <img src="@/assets/images/howto-1.png" width="80px">
          </div>
          <p>1. แอดไลน์ <br><span style="font-weight: 700;">@lamythailand</span></p>
        </div>
        <div style="margin-bottom: 60px;">
          <div class="text-center mt-2">
            <img src="@/assets/images/howto-2.png" width="80px">
          </div>
          <p>2. กดปุ่มสมัครสมาชิก <br><span style="font-weight: 700;">Lamy Club</span></p>
        </div>
        <div style="margin-bottom: 60px;">
          <div class="text-center mt-2">
            <img src="@/assets/images/howto-3.png" width="80px">
          </div>
          <p>3. กรอกข้อมูล <br>และลงทะเบียนใบรับประกันสินค้า<br>เพื่อสะสมยอดซื้อ</p>
        </div>
      </div>

      <!-- Button -->
      <div>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn
              tile
              dark
              color="#000"
              @click="changePage('home')"
              style="width: 100%; height: 48px;"
            >
              <v-icon left>
                mdi-arrow-left 
              </v-icon>
              ย้อนกลับ
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  components: {
    Header
  },  
  methods: {
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>